<style scoped>
.title {
  font-size: 20px;
  font-weight: 549;
}
</style>

<template>
  <div style="padding:20px;background:#fff;border-radius:10px;">
    <h4 class="title">货运平台车辆途经各省道路统计<span style='float:right;font-size:14px;color:rgb(144,161,159);margin-right:20px;margin-top:10px;'>单位：公里</span></h4>
    
    <el-table ref="singleTable" :data="tableData" height="500" stripe style="width: 100%">
      <el-table-column type="index" width="50" label=" "></el-table-column>
      <el-table-column property="name" label="途经省份" align="center"></el-table-column>
      <el-table-column property="total" label="合计" align="center"></el-table-column>
      <el-table-column property="gaosu" align="center" label="高速"></el-table-column>
      <el-table-column property="guodao" label="国道" align="center"></el-table-column>
      <el-table-column property="shengdao" label="省道" align="center"></el-table-column>
      <el-table-column property="xiandao" label="县道" align="center"></el-table-column>
      <el-table-column property="xiangzhendao" label="乡镇村道" align="center"></el-table-column>
      <el-table-column property="qitadao" label="其他道路" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import allData from './index.js'//所有数据
export default {
  data() {
    return {
      tableData: allData
    }
  }
}
</script>